import { type Gateway, gatewaySchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  gateways: z.array(gatewaySchema),
});

interface Params {
  projectId: string;
  installationId?: number | string;
  enabled?: boolean;
  noRetry?: boolean;
}

export function useGateways({
  projectId,
  installationId,
  enabled = true,
  noRetry = false,
}: Params) {
  const url = `/projects/${projectId}/gateways${objectToQueryParams({
    installationId,
  })}`;

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    gateways: Gateway[];
  }>({
    queryKey: queryKeys.getGateways(projectId, installationId?.toString() ?? 'installationId'),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!enabled && !!projectId,
    retry: !noRetry,
  });

  return {
    gateways: data?.gateways || [],
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
